export default __webpack_public_path__ + "static/bones-b2aedcef6aa184b228b343066a1a227a.png";